<svg [attr.width]="Size" [attr.height]="Size" [attr.viewBox]="Icon.ViewBox" fill="none" stroke="currentColor" [attr.stroke-width]="Icon.StrokeWidth" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" [class.agu-icon__svg--solid]="IsSolid">
    @if (IsSolid) {
        @for (d of Icon.SolidPaths; track $index) {
            <path [attr.d]="d" fill="currentColor" [attr.stroke]="Icon.SolidStrokeWidth ? 'currentColor' : 'none'" [attr.stroke-width]="Icon.SolidStrokeWidth ?? null" />
        }
        @for (d of Icon.SolidInk ?? []; track $index) {
            <path [attr.d]="d" fill="none" />
        }
        @for (k of Icon.SolidKnock ?? []; track $index) {
            <path [attr.d]="k.D" [attr.stroke-width]="k.StrokeWidth" [attr.fill]="k.Filled ? 'var(--agu-icon-knock, var(--mj-bg-surface))' : 'none'" stroke="var(--agu-icon-knock, var(--mj-bg-surface))" />
        }
    } @else {
        @for (d of Icon.Paths; track $index) {
            <path [attr.d]="d" />
        }
    }
</svg>
